import {
  IPrintBehaviorSpecifiable, instanceOfIPrintBehaviorSpecifiable,
  IEditBehaviorSpecifiable, instanceOfIEditBehaviorSpecifiable,
  IQuoteBehaviorSpecifiable, instanceOfIQuoteBehaviorSpecifiable,
  ITooltipBehaviorSpecifiable, instanceOfITooltipBehaviorSpecifiable,
  INaturalTextBehaviorSpecifiable, instanceOfINaturalTextBehaviorSpecifiable,
  ITranscribeBehaviorSpecifiable, instanceOfITranscribeBehaviorSpecifiable,
  IEmptyAlertAllowBehaviorSpecifiable, instanceOfIEmptyAlertAllowBehaviorSpecifiable,
  IGroupAlertAllowBehaviorSpecifiable, instanceOfIGroupAlertAllowBehaviorSpecifiable,
  IScriptExecuteTriggerBehaviorSpecifiable, instanceOfIScriptExecuteTriggerBehaviorSpecifiable,
  ICheckBehavior,
} from "../../../../documaker/domain/format/objects";
import { IRectangleCoordinatableObject, instanceOfIRectangleCoordinatableObject } from "./IRectangleCoordinatableObject";
import { ElementTypes } from "./ElementTypes";

export interface ICheckableObject extends
IRectangleCoordinatableObject,
IPrintBehaviorSpecifiable,
IEditBehaviorSpecifiable,
IQuoteBehaviorSpecifiable,
ITooltipBehaviorSpecifiable,
INaturalTextBehaviorSpecifiable,
ITranscribeBehaviorSpecifiable,
IEmptyAlertAllowBehaviorSpecifiable,
IGroupAlertAllowBehaviorSpecifiable,
IScriptExecuteTriggerBehaviorSpecifiable {
  categoryName: string;
  checkBehavior: ICheckBehavior;
}

export function instanceOfICheckableObject<T extends ICheckableObject>(instance: any, type: ElementTypes): instance is ICheckableObject {
  return instance
      && (instance.categoryName !== undefined)
      && (instance.checkBehavior !== undefined)
      && instanceOfIPrintBehaviorSpecifiable(instance)
      && instanceOfIEditBehaviorSpecifiable(instance)
      && instanceOfIQuoteBehaviorSpecifiable(instance)
      && instanceOfITooltipBehaviorSpecifiable(instance)
      && instanceOfINaturalTextBehaviorSpecifiable(instance)
      && instanceOfITranscribeBehaviorSpecifiable(instance)
      && instanceOfIEmptyAlertAllowBehaviorSpecifiable(instance)
      && instanceOfIGroupAlertAllowBehaviorSpecifiable(instance)
      && instanceOfIScriptExecuteTriggerBehaviorSpecifiable(instance)
      && instanceOfIRectangleCoordinatableObject<T>(instance, type);
}
